import api from '@/configs/ApiConfig';
import equipmentCategoryConfig from '@/enums/EquipmentCategoryEnum';

const WoodSpecie = () =>
    import(/* webpackChunkName: "woodSpecie" */ '@/views/catalogues/wood/woodSpeie/WoodSpecie.vue');

const VeneerOuterGrade = () =>
    import(
        /* webpackChunkName: "veneerOuterGrade" */ '@/views/catalogues/veneer/veneerOuterGrade/VeneerOuterGrade.vue'
    );

const VeneerSize = () =>
    import(/* webpackChunkName: "veneerSize" */ '@/views/catalogues/veneer/veneerSize/VeneerSize.vue');

const VeneerThickness = () =>
    import(/* webpackChunkName: "veneerThickness" */ '@/views/catalogues/veneer/veneerThickness/VeneerThickness.vue');

const VeneerSpecie = () =>
    import(/* webpackChunkName: "veneerSpecie" */ '@/views/catalogues/veneer/veneerSpecie/VeneerSpecie.vue');

const VeneerWetness = () =>
    import(/* webpackChunkName: "veneerWetness" */ '@/views/catalogues/veneer/veneerWetness/VeneerWetness.vue');

const VeneerMaxUsedShiftCountOfStorage = () =>
    import(
        /* webpackChunkName: "veneerMaxUsedShiftCountOfStorage" */ '@/views/catalogues/veneer/veneerMaxUsedShiftCountOfStorage/VeneerMaxUsedShiftCountOfStorage.vue'
    );

const VeneerPatchingGrade = () =>
    import(
        /* webpackChunkName: "veneerPatchingGrade" */ '@/views/catalogues/veneer/veneerPatchingGrade/VeneerPatchingGrade.vue'
    );

const Veneer = () => import(/* webpackChunkName: "veneer" */ '@/views/catalogues/veneer/Veneer.vue');

const PlywoodSize = () =>
    import(/* webpackChunkName: "plywoodSize" */ '@/views/catalogues/plywood/plywoodSize/PlywoodSize.vue');

const PlywoodThickness = () =>
    import(
        /* webpackChunkName: "plywoodThickness" */ '@/views/catalogues/plywood/plywoodThickness/PlywoodThickness.vue'
    );

const PlywoodGrade = () =>
    import(/* webpackChunkName: "plywoodGrade" */ '@/views/catalogues/plywood/plywoodGrade/PlywoodGrade.vue');

const PlywoodSpecie = () =>
    import(/* webpackChunkName: "plywoodSpecie" */ '@/views/catalogues/plywood/plywoodSpecie/PlywoodSpecie.vue');

const PlywoodSurface = () =>
    import(/* webpackChunkName: "plywoodSurface" */ '@/views/catalogues/plywood/plywoodSurface/PlywoodSurface.vue');

const PlywoodWaterResistance = () =>
    import(
        /* webpackChunkName: "plywoodWaterResistance" */ '@/views/catalogues/plywood/plywoodWaterResistance/PlywoodWaterResistance.vue'
    );

const ComplectationRule = () =>
    import(
        /* webpackChunkName: "complectationRule" */ '@/views/catalogues/plywood/complectationRule/ComplectationRule.vue'
    );

const WarehouseVeneer = () =>
    import(
        /* webpackChunkName: "warehouseVeneer" */ '@/views/catalogues/warehouse/warehouseVeneer/WarehouseVeneer.vue'
    );

const WarehousePlywood = () =>
    import(
        /* webpackChunkName: "warehousePlywood" */ '@/views/catalogues/warehouse/warehousePlywood/WarehousePlywood.vue'
    );

const ShiftTml = () => import(/* webpackChunkName: "shiftTml" */ '@/views/catalogues/shift/shiftTml/ShiftTml.vue');

const DaySchedule = () =>
    import(/* webpackChunkName: "daySchedule" */ '@/views/catalogues/shift/daySchedule/DaySchedule.vue');

const OrderCustomProperty = () =>
    import(
        /* webpackChunkName: "orderCustomProperty" */ '@/views/catalogues/orderCustomProperty/OrderCustomProperty.vue'
    );

const EquipmentType = () =>
    import(/* webpackChunkName: "equipmentType" */ '@/views/catalogues/equipment/equipmentType/EquipmentType.vue');

const EquipmentSettings = () =>
    import(
        /* webpackChunkName: "equipmentSettings" */ '@/views/catalogues/equipment/equipmentSettings/EquipmentSettings.vue'
    );

const WarehouseVeneerEquipmentTypeLink = () =>
    import(
        /* webpackChunkName: "warehouseVeneerEquipmentTypeLink" */ '@/views/catalogues/equipment/warehouseVeneerEquipmentTypeLink/WarehouseVeneerEquipmentTypeLink.vue'
    );

const WarehousePlywoodEquipmentTypeLink = () =>
    import(
        /* webpackChunkName: "warehousePlywoodEquipmentTypeLink" */ '@/views/catalogues/equipment/warehousePlywoodEquipmentTypeLink/WarehousePlywoodEquipmentTypeLink.vue'
    );

const PlywoodProductionDistribution = () =>
    import(
        /* webpackChunkName: "plywoodProductionDistribution" */ '@/views/catalogues/equipment/plywoodProductionDistribution/PlywoodProductionDistribution.vue'
    );

const EquipmentTab = () =>
    import(/* webpackChunkName: "equipmentTab" */ '@/views/catalogues/equipment/equipmentTab/EquipmentTab.vue');

const Equipment = () =>
    import(
        /* webpackChunkName: "equipmentTab-equipment" */ '@/views/catalogues/equipment/equipmentTab/equipment/Equipment.vue'
    );

const VeneerEquipmentProcess = () =>
    import(
        /* webpackChunkName: "equipmentTab-veneerEquipmentProcess" */ '@/views/catalogues/equipment/equipmentTab/veneerEquipmentProcess/VeneerEquipmentProcess.vue'
    );

const PlywoodProductionEquipment = () =>
    import(
        /* webpackChunkName: "equipmentTab-plywoodProductionEquipment" */ '@/views/catalogues/equipment/equipmentTab/plywoodProductionEquipment/PlywoodProductionEquipment.vue'
    );

const PlywoodProcessingEquipment = () =>
    import('@/views/catalogues/equipment/equipmentTab/plywoodProcessingEquipment/PlywoodProcessingEquipment.vue');

const PlywoodProcessingProcess = () =>
    import(
        '@/views/catalogues/equipment/equipmentTab/plywoodProcessing/plywoodProcessingProcess/PlywoodProcessingProcess.vue'
    );

const EquipmentPlywoodProcessingProcessLink = () =>
    import(
        '@/views/catalogues/equipment/equipmentTab/plywoodProcessing/equipmentPlywoodProcessingProcessLink/EquipmentPlywoodProcessingProcessLink.vue'
    );

const EquipmentPlywoodProcessingProcessGroupLink = () =>
    import(
        '@/views/catalogues/equipment/equipmentTab/plywoodProcessing/equipmentPlywoodProcessingProcessGroupLink/EquipmentPlywoodProcessingProcessGroupLink.vue'
    );

const PlywoodProcessingProcessGroupLink = () =>
    import(
        '@/views/catalogues/equipment/equipmentTab/plywoodProcessing/plywoodProcessingProcessGroupLink/PlywoodProcessingProcessGroupLink.vue'
    );
const PlywoodProcessingProcessGroup = () =>
    import(
        '@/views/catalogues/equipment/equipmentTab/plywoodProcessing/plywoodProcessingProcessGroup/PlywoodProcessingProcessGroup.vue'
    );
const PlywoodProductionProcess = () =>
    import(
        /* webpackChunkName: "equipmentTab-plywoodProductionProcess" */ '@/views/catalogues/equipment/equipmentTab/plywoodProductionProcess/PlywoodProductionProcess.vue'
    );

const VeneerEquipmentProcessLink = () =>
    import(
        /* webpackChunkName: "equipmentTab-veneerEquipmentProcessLink" */ '@/views/catalogues/equipment/equipmentTab/veneerEquipmentProcessLink/VeneerEquipmentProcessLink.vue'
    );

const VeneerEquipmentGroupLink = () =>
    import(
        /* webpackChunkName: "equipmentTab-veneerEquipmentGroupLink" */ '@/views/catalogues/equipment/equipmentTab/veneerEquipmentGroupLink/VeneerEquipmentGroupLink.vue'
    );

const VeneerEquipmentProcessGroupLink = () =>
    import(
        /* webpackChunkName: "equipmentTab-veneerEquipmentProcessGroupLink" */ '@/views/catalogues/equipment/equipmentTab/veneerEquipmentProcessGroupLink/VeneerEquipmentProcessGroupLink.vue'
    );

const PlywoodProductionSupportEquipment = () =>
    import(
        /* webpackChunkName: "equipmentTab-plywoodProductionSupportEquipment" */ '@/views/catalogues/equipment/equipmentTab/plywoodProductionSupportEquipment/PlywoodProductionSupportEquipment.vue'
    );

const VeneerEquipmentGroup = () =>
    import(
        /* webpackChunkName: "equipmentTab-veneerEquipmentGroup" */ '@/views/catalogues/equipment/equipmentTab/veneerEquipmentGroup/VeneerEquipmentGroup.vue'
    );

export default [
    {
        name: 'woodSpecie',
        path: api.catalogues.woodSpecie,
        component: WoodSpecie,
    },
    {
        name: 'veneerOuterGrade',
        path: api.catalogues.veneerOuterGrade,
        component: VeneerOuterGrade,
    },
    {
        name: 'veneerSize',
        path: api.catalogues.veneerSize,
        component: VeneerSize,
    },
    {
        name: 'veneerThickness',
        path: api.catalogues.veneerThickness,
        component: VeneerThickness,
    },
    {
        name: 'veneerSpecie',
        path: api.catalogues.veneerSpecie,
        component: VeneerSpecie,
    },
    {
        name: 'veneerWetness',
        path: api.catalogues.veneerWetness,
        component: VeneerWetness,
    },
    {
        name: 'veneerMaxUsedShiftCountOfStorage',
        path: api.catalogues.veneerMaxUsedShiftCountOfStorage,
        component: VeneerMaxUsedShiftCountOfStorage,
    },
    {
        name: 'veneerPatchingGrade',
        path: api.catalogues.veneerPatchingGrade,
        component: VeneerPatchingGrade,
    },
    {
        name: 'veneer',
        path: api.catalogues.veneer,
        component: Veneer,
    },
    {
        name: 'plywoodSize',
        path: api.catalogues.plywoodSize,
        component: PlywoodSize,
    },
    {
        name: 'plywoodThickness',
        path: api.catalogues.plywoodThickness,
        component: PlywoodThickness,
    },
    {
        name: 'plywoodGrade',
        path: api.catalogues.plywoodGrade,
        component: PlywoodGrade,
    },
    {
        name: 'plywoodSpecie',
        path: api.catalogues.plywoodSpecie,
        component: PlywoodSpecie,
    },
    {
        name: 'plywoodSurface',
        path: api.catalogues.plywoodSurface,
        component: PlywoodSurface,
    },
    {
        name: 'plywoodWaterResistance',
        path: api.catalogues.plywoodWaterResistance,
        component: PlywoodWaterResistance,
    },
    {
        name: 'complectationRule',
        path: api.catalogues.complectationRule,
        component: ComplectationRule,
    },
    {
        name: 'warehouseVeneer',
        path: api.catalogues.warehouseVeneer,
        component: WarehouseVeneer,
    },
    {
        name: 'warehousePlywood',
        path: api.catalogues.warehousePlywood,
        component: WarehousePlywood,
    },
    {
        name: 'shiftTml',
        path: api.catalogues.shiftTml,
        component: ShiftTml,
    },
    {
        name: 'daySchedule',
        path: api.catalogues.daySchedule,
        component: DaySchedule,
    },
    {
        name: 'cataloguesEquipmentType',
        path: api.catalogues.equipmentType,
        component: EquipmentType,
    },
    {
        name: 'equipmentSettings',
        path: api.catalogues.equipmentSettings,
        component: EquipmentSettings,
    },
    {
        name: 'warehouseVeneerEquipmentTypeLink',
        path: api.catalogues.warehouseVeneerEquipmentTypeLink,
        component: WarehouseVeneerEquipmentTypeLink,
    },
    {
        name: 'warehousePlywoodEquipmentTypeLink',
        path: api.catalogues.warehousePlywoodEquipmentTypeLink,
        component: WarehousePlywoodEquipmentTypeLink,
    },
    {
        name: 'plywoodProductionDistribution',
        path: api.catalogues.plywoodProductionDistribution,
        component: PlywoodProductionDistribution,
    },
    {
        name: 'orderCustomProperty',
        path: api.catalogues.orderCustomProperty,
        component: OrderCustomProperty,
    },
    {
        name: 'equipmentTab',
        path: api.catalogues.equipmentTab,
        component: EquipmentTab,
        children: [
            {
                name: 'equipmentTab-veneerProductionEquipment',
                path: api.catalogues.veneerProductionEquipment.slice(1),
                component: Equipment,
                props: () => ({equipmentCategory: equipmentCategoryConfig.VeneerProductionEquipment}),
            },
            {
                name: 'equipmentTab-veneerProcessingEquipment',
                path: api.catalogues.veneerProcessingEquipment.slice(1),
                component: Equipment,
                props: () => ({equipmentCategory: equipmentCategoryConfig.VeneerProcessingEquipment}),
            },
            {
                name: 'equipmentTab-veneerEquipmentProcess',
                path: api.catalogues.veneerEquipmentProcess.slice(1),
                component: VeneerEquipmentProcess,
            },
            {
                name: 'equipmentTab-plywoodProductionEquipment',
                path: api.catalogues.plywoodProductionEquipment.slice(1),
                component: PlywoodProductionEquipment,
            },
            {
                name: 'equipmentTab-plywoodProductionProcess',
                path: api.catalogues.plywoodProductionProcess.slice(1),
                component: PlywoodProductionProcess,
            },
            {
                name: 'equipmentTab-veneerEquipmentProcessLink',
                path: api.catalogues.veneerEquipmentProcessLink.slice(1),
                component: VeneerEquipmentProcessLink,
            },
            {
                name: 'equipmentTab-veneerEquipmentGroupLink',
                path: api.catalogues.veneerEquipmentGroupLink.slice(1),
                component: VeneerEquipmentGroupLink,
            },
            {
                name: 'equipmentTab-veneerEquipmentProcessGroupLink',
                path: api.catalogues.veneerEquipmentProcessGroupLink.slice(1),
                component: VeneerEquipmentProcessGroupLink,
            },
            {
                name: 'equipmentTab-plywoodProductionSupportEquipment',
                path: api.catalogues.plywoodProductionSupportEquipment.slice(1),
                component: PlywoodProductionSupportEquipment,
            },
            {
                name: 'equipmentTab-veneerEquipmentGroup',
                path: api.catalogues.veneerEquipmentGroup.slice(1),
                component: VeneerEquipmentGroup,
            },
            {
                name: 'equipmentTab-plywoodProcessing-plywoodProcessingEquipment',
                path: api.catalogues.plywoodProcessingEquipment.slice(1),
                component: PlywoodProcessingEquipment,
            },
            {
                name: 'equipmentTab-plywoodProcessing-plywoodProcessingProcess',
                path: api.catalogues.plywoodProcessingProcess.slice(1),
                component: PlywoodProcessingProcess,
            },
            {
                name: 'equipmentTab-plywoodProcessing-equipmentPlywoodProcessingProcessLink',
                path: api.catalogues.equipmentPlywoodProcessingProcessLink.slice(1),
                component: EquipmentPlywoodProcessingProcessLink,
            },
            {
                name: 'equipmentTab-plywoodProcessing-equipmentPlywoodProcessingProcessGroupLink',
                path: api.catalogues.equipmentPlywoodProcessingProcessGroupLink.slice(1),
                component: EquipmentPlywoodProcessingProcessGroupLink,
            },
            {
                name: 'equipmentTab-plywoodProcessing-plywoodProcessingProcessGroupLink',
                path: api.catalogues.plywoodProcessingProcessGroupLink.slice(1),
                component: PlywoodProcessingProcessGroupLink,
            },
            {
                name: 'equipmentTab-plywoodProcessing-plywoodProcessingProcessGroup',
                path: api.catalogues.plywoodProcessingProcessGroup.slice(1),
                component: PlywoodProcessingProcessGroup,
            },
        ],
    },
];
